<div class="container-fluid">
    <div class="row">
        <div class="col-md-3">
            <a routerLink="/naac/aqar/2023-24"  *ngIf="showSideMenu"> <i class="fas fa-long-arrow-alt-left"></i> Go Back</a>
            <nav id="secondary-navigation" *ngIf="showSideMenu">
                <!-- Header -->
                <header class="header">
                    <h5>CRITERION-3</h5>
                </header>
                <!-- /Header -->
                <ul>
                    <li routerLinkActive="active">
                        <a  routerLink="/naac/aqar/2023-24/criteria3/3-2-2" (click)="checkRoute()">3.2.2</a>
                    </li>
                    <li routerLinkActive="active">
                        <a  routerLink="/naac/aqar/2023-24/criteria3/3-5-1" (click)="checkRoute()">3.5.1</a>
                    </li>
                   
                </ul>
            </nav>
        </div>
        <div [ngClass]="fullWidth ? 'col-md-12' : 'col-md-9'">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>